import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

export const useProductos = () => {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProductos = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const { data, error } = await supabase
        .from('productos')
        .select(`
          *,
          categorias (
            id,
            nomCategoria,
            activo
          )
        `)
        .order('orden', { ascending: true });

      if (error) throw error;
      setProductos(data || []);
    } catch (err) {
      console.error('Error fetching productos:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProductos();
  }, []);

  const createProducto = async (productoData) => {
    try {
      const { data, error } = await supabase
        .from('productos')
        .insert([productoData])
        .select(`
          *,
          categorias (
            id,
            nomCategoria,
            activo
          )
        `)
        .single();

      if (error) throw error;
      await fetchProductos();
      return data;
    } catch (err) {
      console.error('Error creating producto:', err);
      throw err;
    }
  };

  const updateProducto = async (id, productoData) => {
    try {
      const { data, error } = await supabase
        .from('productos')
        .update(productoData)
        .eq('id', id)
        .select(`
          *,
          categorias (
            id,
            nomCategoria,
            activo
          )
        `)
        .single();

      if (error) throw error;
      await fetchProductos();
      return data;
    } catch (err) {
      console.error('Error updating producto:', err);
      throw err;
    }
  };

  const deleteProducto = async (id) => {
    try {
      const { error } = await supabase
        .from('productos')
        .delete()
        .eq('id', id);

      if (error) throw error;
      await fetchProductos();
    } catch (err) {
      console.error('Error deleting producto:', err);
      throw err;
    }
  };

  return {
    productos,
    loading,
    error,
    createProducto,
    updateProducto,
    deleteProducto,
    refetch: fetchProductos
  };
};
